import { endsWith, get, isNil, isString, startsWith } from 'lodash';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateParser,
} from '@ngx-translate/core';

import * as defaultDictionary from '@i18n/translations/default.en-us.json';

import { environment } from '../../environments/environment';

/**
 * DefaultMissingTranslationHandler is used to handle missing translations
 * by returning the key itself if the default translation is not found.
 */
export class DefaultMissingTranslationHandler
  implements MissingTranslationHandler
{
  public handle(params: MissingTranslationHandlerParams): string {
    const isEnableSpecialTranslationSymbol =
      get(environment, 'ENABLE_SPECIAL_TRANSLATION_SYMBOL', 'false') === 'true';

    let defaultTranslation = get(defaultDictionary, params.key);

    // only add special symbols if the default translation is found
    if (isNil(defaultTranslation)) {
      defaultTranslation = params.key;
    } else if (
      isEnableSpecialTranslationSymbol &&
      isString(defaultTranslation) &&
      // avoid adding special symbols if they already exist
      !startsWith(defaultTranslation, '#') &&
      !endsWith(defaultTranslation, '#')
    ) {
      defaultTranslation = `#${defaultTranslation}#`;
    }

    const translationParser = params.translateService?.parser;

    if (!translationParser) {
      return defaultTranslation;
    }

    const interpolate: TranslateParser['interpolate'] =
      translationParser.interpolate.bind(translationParser);

    // use this to handle default translation interpolation
    return interpolate(defaultTranslation, params.interpolateParams ?? {});
  }
}
